<div class="product-single" [ngClass]="{ badges: hasBadge, normal: !wide, wide: wide }">
  <a>
    @if (hasBadge) {
      <div class="flag">
        @for (badge of product | badges: 'flag' : excludeBadges; track badge) {
          <em [class]="badge.badgeType">
            {{ badge.value ? '-' + badge.value + '%' : null }}
          </em>
        }
      </div>
    }
    <dl [class]="i18n.language">
      <dt
        [ngClass]="{ 'out-of-stock': product.productStatus === PRODUCT_STATUS.OUT_OF_STOCK }"
        (click)="onSelectProduct(product)"
      >
        <mat-checkbox
          class="checkbox"
          [checked]="isChecked"
          (change)="onSelectProduct(product)"
          (click)="onSelectProduct(product)"
        ></mat-checkbox>
        @if (numberTag) {
          <span class="text-number">{{ numberTag }}</span>
        }
        <img src="{{ product.images[0]?.endpoint }}" />
      </dt>
      <dd (click)="goToProductDetail()">
        <p>[{{ product.brand.englishName }}]</p>
        <p>{{ product.englishName }}</p>
        @if ((product?.mapperSaleProducts)[0].productOption.reviewDetails?.ratingAvg) {
          <div class="review-rating">
            <div style="align-items: center; z-index: 1">
              <ngx-stars
                [readonly]="true"
                [size]="1"
                [maxStars]="5"
                [initialStars]="(product?.mapperSaleProducts)[0].productOption.reviewDetails?.ratingAvg"
                [color]="'#e04fa3'"
              >
              </ngx-stars>
              <!-- <span style="font-weight: bold; font-size: 20px">Rating is {{ ratingDisplay }} out of 5</span> -->
            </div>
            <div style="display: flex; align-items: center">
              <span class="rating-total">{{
                (product?.mapperSaleProducts)[0].productOption.reviewDetails?.ratingAvg | number: '1.2-2'
              }}</span>
              <span class="review-count">
                ({{ (product?.mapperSaleProducts)[0].productOption.reviewDetails?.reviewCount | number }})</span
              >
            </div>
          </div>
        }
        <p>
          @if (!(product?.mapperSaleProducts)[0].productOption.finalSaleSupplyPrice) {
            <em>
              ${{
                product.minSalePriceUSD !== product.maxSalePriceUSD
                  ? (product.minSalePriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minSalePriceUSD | currency: 'USD' : '' : '0.2')
              }}<span>{{
                product.minSupplyRate !== product.maxSupplyRate
                  ? (product.minSupplyRate | salesRate) + '%~' + (product.maxSupplyRate | salesRate) + '%'
                  : (product.minSupplyRate | salesRate) + '%'
              }}</span>
            </em>
            @if ((product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
              <del
                >MSRP ${{
                  product.minFixedMsrpPriceUSD !== product.maxFixedMsrpPriceUSD
                    ? (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                    : (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2')
                }}</del
              >
            }
            @if (!(product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
              <del>
                MSRP ${{
                  product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                    ? (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                    : (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2')
                }}
              </del>
            }
          }
          @if ((product?.mapperSaleProducts)[0].productOption.finalSaleSupplyPrice) {
            <p class="price-area" style="margin-top: 2px">
              <em>
                ${{
                  product.minFinalSaleSupplyPriceUSD !== product.maxFinalSaleSupplyPriceUSD
                    ? (product.minFinalSaleSupplyPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                    : (product.maxFinalSaleSupplyPriceUSD | currency: 'USD' : '' : '0.2')
                }}
                <!-- <span [class.hide]="classes.best && !classes.badges">{{ -->
                <span>{{
                  product.minFinalSaleSupplyRate !== product.maxFinalSaleSupplyRate
                    ? (product.minFinalSaleSupplyRate | salesRate) +
                      '%~' +
                      (product.maxFinalSaleSupplyRate | salesRate) +
                      '%'
                    : (product.minFinalSaleSupplyRate | salesRate) + '%'
                }}</span>
              </em>
            </p>
            <div class="final-price">
              <div style="display: flex; align-items: center">
                <!-- <del [class.hide]="classes.best && !classes.badges" -->
                @if ((product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
                  <del
                    >MSRP ${{
                      product.minFixedMsrpPriceUSD !== product.maxFixedMsrpPriceUSD
                        ? (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                        : (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2')
                    }}</del
                  >
                }
                @if (!(product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
                  <del>
                    MSRP ${{
                      product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                        ? (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                        : (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2')
                    }}
                  </del>
                }
              </div>
              <div style="display: flex; align-items: center; padding-left: 3px">
                <del style="color: #232323 !important">
                  ${{
                    product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                      ? (product.minSalePriceUSD | currency: 'USD' : '' : '0.2') + '~'
                      : (product.maxSalePriceUSD | currency: 'USD' : '' : '0.2')
                  }}
                  <del style="color: #e04fa3 !important">
                    {{
                      product.minSupplyRate !== product.maxSupplyRate
                        ? (product.minSupplyRate | salesRate) + '%~' + (product.maxSupplyRate | salesRate) + '%'
                        : (product.minSupplyRate | salesRate) + '%'
                    }}
                  </del>
                </del>
              </div>
            </div>
          }
        </p>
        <app-product-stock-badges [product]="product" />
        <!-- <div class="badge" *ngIf="hasBadge">
            <ng-container *ngFor="let badge of product | badges: 'badge':excludeBadges">
              <span [class]="badge.badgeType">{{ badge.badgeType | commonCode: 'BADGE_TYPE' }}</span>
            </ng-container>
          </div> -->
      </dd>
    </dl>
  </a>
  @if (product.productStatus !== PRODUCT_STATUS.OUT_OF_STOCK) {
    <a (click)="addToCartModal()" class="button-cart"></a>
  }
</div>
